import { GivelifyLabel } from '@givelify/ui';
import { styled } from '@mui/material';

export const SettingsTitleRow = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('mobile')]: {
        padding: '0 16px',
    },
}));

export const SettingsSecondTitle = styled(GivelifyLabel)({
    width: '100%',
});

export const TitleRowWrapper = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
});

export const SettingsRightColumn = styled('div')(({ theme }) => ({
    alignSelf: 'center',
    marginLeft: 'auto',
    [theme.breakpoints.down('mobile')]: {
        order: 1,
        marginTop: theme.spacing(2),
        width: '100%',
    },
}));

export const TitleLabelWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
});

export const SettingsTitle = styled(GivelifyLabel)({
    display: 'block',
    '&:focus': {
        outline: 'none',
    },
});

export const SettingsDivider = styled('div')({
    boxShadow: 'inset 0px -1px 0px #C2C0CD',
    width: '100%',
    height: 1,
    marginTop: 16,
    order: 2,
});

export const SubmitButtonsHolderSingle = styled('div')(({ theme }) => ({
    marginTop: 16,
    textAlign: 'right',
    float: 'right',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
        height: 72,
        justifyContent: 'center',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        background: '#FFFFFF',
    },
}));
